import CrudBase from '../../../CrudBase';
import axios from '../../../../axios-common';

class nonPaymentApi extends CrudBase {

  getNonPayment = (params) => axios.get(`${this.endpoint}/get-by`, params);

  defaultMethods = {
    ...this.defaultMethods,
    getNonPayment: this.getNonPayment,
  }
}

const nonPayment = new nonPaymentApi('/api/v1/non-payment');

export default nonPayment.defaultMethods;

